export default function ArchivedReportInstanceCommentDirective() {
  return {
    template: require('./report-instance-comment.html'),
    scope: {
      reportInstanceComment: '=',
    },
    controller: 'ArchivedReportInstanceCommentController',
    controllerAs: 'archivedReportInstanceCommentVM',
    bindToController: true,
    replace: true
  };
}
